import React from 'react';
import DataTable from 'react-data-table-component';
import { useNavigate } from 'react-router-dom';
import { IconEdit } from '@tabler/icons-react';
import { useNavigateWithSlugHook, } from "../../../../src/config/routes/guards/slug";

const DatatableModules = (props) => {
  const navigate = useNavigateWithSlugHook();
  const handleChangePage = (path) => {
    navigate(path);
  };

  const columns = [
    {
      name: 'Aksi',
      width: '100px',
      cell: (row) => (
        <>
          <button
            className="btn btn-outline-warning btn-sm"
            type="button"
            title="Ubah Modules"
            onClick={() => props.handleEdit(row)}
          >
            <IconEdit stroke={2} />
          </button>
        </>
      ),
    },
    {
      name: 'Nama Modul',
      selector: (row) => row.namaModule,
    },
    {
      name: 'Path',
      selector: (row) => row.pathModule,
    },
    {
      name: 'Created At',
      selector: (row) => row.createdAt,
    },
    {
      name: 'Updated At',
      selector: (row) => row.updatedAt,
    },
  ];

  return (
    <>
      <h5 className="card-title">Daftar Modul</h5>
      <DataTable
        columns={columns}
        data={props.modules}
        pagination
        fixedHeader
        highlightOnHover
        subHeader
        subHeaderComponent={
          <input
            type="text"
            placeholder="Search Nama Module"
            className="w-50 form-control m-3"
            values={props.search}
            onChange={(e) => props.handleChangeSearch(e.target.value)}
          />
        }
        subHeaderAlign="center"
      />
    </>
  );
};

export default DatatableModules;
